import React from "react";

const TransactionTabNavigation = ({ activeTab, setActiveTab, visibleTabs }) => {
  // Navigation is now a "Dumb Component" — it just renders what the parent says is visible.
  return (
    <div className="border-b border-gray-200 bg-white pt-3">
      <div className="flex space-x-1 px-6">
        {visibleTabs.map(tab => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            className={`px-4 py-3 text-sm font-medium rounded-t-lg transition-colors border-b-2 flex items-center gap-2 border-none cursor-pointer 
                ${activeTab === tab.key
                ? "border-blue-500 text-blue-600 bg-blue-50"
                : "border-transparent text-gray-500 hover:text-gray-700 hover:bg-gray-50"}`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Visual Indicator if no tabs are available */}
      {visibleTabs.length === 0 && (
        <div className="px-6 py-2 bg-amber-50 text-amber-700 text-xs italic">
          No available tabs for this Transaction Type.
        </div>
      )}
    </div>
  );
};

export default TransactionTabNavigation;